/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Dashboard_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "Your usage and recent activity, with quick access to your projects and spaces. Admins can also view organization-wide metrics and filter by user, team, or ti..." |
*
* @param {Uno_Edu_Intro_Dashboard_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_dashboard_chip2_answer = /** @type {((inputs?: Uno_Edu_Intro_Dashboard_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Dashboard_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre Nutzung und jüngste Aktivität mit Schnellzugriff auf Ihre Projekte und Spaces. Administratoren können zusätzlich organisationsweite Metriken anzeigen und nach Benutzer, Team oder Zeitraum filtern.")
	return /** @type {LocalizedString} */ ("Your usage and recent activity, with quick access to your projects and spaces. Admins can also view organization-wide metrics and filter by user, team, or time period.")
});